import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FaFileInvoiceDollar, FaShareAlt, FaDownload, FaTimes } from "react-icons/fa";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios"; 
import { toast } from "react-toastify"; 
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FaEye } from "react-icons/fa"; 
import Grid from "../components/Grid"; // Import the Grid component
import { parse, isAfter, isBefore, isEqual } from "date-fns"
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // Use your actual base URL

const Invoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSearchField, setSelectedSearchField] = useState("invoiceNumber");
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [totalInvoiceAmount, setTotalInvoiceAmount] = useState(0);
  const [totalBalanceAmount, setTotalBalanceAmount] = useState(0);
  //const [clicked, setClicked] = useState(false);
  const [organizationContactNo, setOrganizationContactNo] = useState("");
  const [confirmCancelOpen, setConfirmCancelOpen] = useState(false);
  const [selectedInvoiceIdToCancel, setSelectedInvoiceIdToCancel] = useState(null);
  const [organizationContactName, setOrganizationContactName] = useState("");

  useEffect(() => {
    fetchInvoices();
    fetchOrganizationSettings(); // Fetch organization settings on component mount
  }, []);

  const fetchInvoices = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token is missing. Please log in again.");
          return;
        }

        const response = await axios.get(`${API_BASE_URL}/invoices/get`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });


        const formattedInvoices = response.data.map((invoice) => ({
          id: invoice._id,
          invoiceNumber: invoice.invoice_id,
          salesOrderNumber: invoice.sales_order_id.sales_order_id,
          customerId: invoice.customer_id.customer_code,
          customerName: invoice.customer_id.customer_name || "Unknown",
          customerMobile: invoice.customer_id.cus_mobileno || "Unknown",
          taxAmount: invoice.sales_order_id.tax_amount || 0,
          balance: invoice.blance || 0,
          finalAmount: invoice.sales_order_id.final_amount || 0,
          status: invoice.status || "Unknown",
          originalCreatedAt: invoice.createdAt, // Keep original date for sorting
          createdAt: invoice.createdAt ? new Date(invoice.createdAt).toLocaleDateString("en-GB") : "N/A", // Formats as dd-mm-yyyy,
          dueDate: invoice.due_date
            ? new Date(invoice.due_date).toLocaleDateString("en-GB") // Formats as dd-mm-yyyy
            : "N/A",
        }))

        setInvoices(formattedInvoices);

        //console.log("Formatted All Invoices data:", formattedInvoices);
      } catch (error) {
        console.error("Error fetching invoices:", error);
        toast.error("Failed to fetch invoices. Please try again.");
      }
    };

  const handleDownloadExcel = async () => {
  const dataToExport = filteredInvoices; // already includes search + date filter

  if (dataToExport.length === 0) {
    toast.warn("No invoice data available to download.");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Invoices");

  const headerRow = [
    "Invoice Number",
    "Sales Order Number",
    "Customer Code",
    "Customer Name",
    "Customer Mobile",
    "Tax Amount",
    "Final Amount",
    "Balance",
    "Status",
    "Created Date",
    "Due Date",
  ];
  worksheet.addRow(headerRow);

  const header = worksheet.getRow(1);
  header.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD966" },
    };
    cell.font = { bold: true };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  dataToExport.forEach((invoice) => {
    worksheet.addRow([
      invoice.invoiceNumber,
      invoice.salesOrderNumber,
      invoice.customerId,
      invoice.customerName,
      invoice.customerMobile,
      invoice.taxAmount,
      invoice.finalAmount,
      invoice.balance,
      invoice.status,
      invoice.createdAt,
      invoice.dueDate,
    ]);
  });

  worksheet.columns.forEach((column) => {
    column.width = column.header
      ? column.header.toString().length < 20
        ? 20
        : column.header.toString().length
      : 20;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "invoices.xlsx");
};


  const getInvoiceById = async (invoiceNumber) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token is missing. Please log in again.");
        return null;
      }

      const response = await axios.get(`${API_BASE_URL}/invoices/get/${invoiceNumber}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data) {
        const invoicedata = {
          invoiceNumber: response.data.invoice_id,
          salesOrderNumber: response.data.sales_order_id.sales_order_id,
          customerId: response.data.customer_id.customer_code,
          customerName: response.data.customer_id.customer_name || "Unknown",
          customerMobile: response.data.customer_id.cus_mobileno || "Unknown",
          taxAmount: response.data.sales_order_id.tax_amount || 0,
          finalAmount: response.data.sales_order_id.final_amount || 0,
          balance: response.data.blance || 0,
          createdAt: response.data.createdAt ? new Date(response.data.createdAt).toLocaleDateString("en-GB") : "N/A",
          longitude: response.data.pickup_location_id.longitude || "N/A",
          latitude: response.data.pickup_location_id.latitude || "N/A",
          dueDate: response.data.due_date ? new Date(response.data.due_date).toLocaleDateString("en-GB") : "N/A",
          items: response.data.sales_order_id.items.map((item) => ({
            productCode: item.product_id.product_code || "N/A",
            productName: item.product_id.product_name || "N/A",
            quantity: item.approved_qty || 0,
            unitPrice: item.unit_price || 0,
            totalPrice: item.total_price || 0,
            unit: item.product_id.unit?.unit_name,
          })),
          payment_receipts: response.data.payment_receipts.map((receipt) => ({
            payment_receipt_id: receipt.payment_receipt_id,
            amount_applied: receipt.amount_applied,
          })),
          credit_notes: response.data.credit_notes.map((note) => ({
            credit_note_id: note.credit_note_id.credit_note_code || "N/A",
            credited_amount: note.credited_amount || 0,
          })),
        }
        //setSelectedInvoice(invoicedata);
        return invoicedata
      } else {
        return null
      }
    } catch (error) {
      console.error("Error fetching invoice:", error)
      toast.error("Failed to fetch invoice. Please try again.")
      return null
    }
  }

const getBase64ImageFromUrl = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const currency = (v) =>
  (Number(v ?? 0)).toLocaleString("en-LK", { style: "currency", currency: "LKR", minimumFractionDigits: 2 }).replace("LKR", "LKR ");

 const handlePrintInvoice = async (invoice, orgSettings) => {
  try {
    if (!invoice) return console.error("No invoice data provided.");

    // ---------- ORG SETTINGS ----------
    let settings = orgSettings;
    if (!settings) {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${API_BASE_URL}/organizations/getSettings`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        settings = {
          contact_number: response.data.contact_number,
          contact_name: response.data.contact_name,
          organization_logo: response.data.organization_logo, // base64 PNG/JPEG
          invoice_footer_note: response.data.invoice_footer_note,
          invoice_footer_terms: response.data.invoice_footer_terms,
          org_name: response.data.organization_name,
          org_address_line1: response.data.org_address_line1,
          org_address_line2: response.data.org_address_line2,
          org_city: response.data.org_city,
          org_country: response.data.org_country,
          
        };
      } catch (err) {
        console.warn("Failed to fetch organization settings:", err);
        settings = {};
      }
    }

    // ---------- PDF BASE ----------
    const pdf = new jsPDF("p", "mm", "a4");
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();
    const margin = 18;

    // Brand colors (from sample)
    const brandBrown = [83, 51, 34];          // headings / dark brown
    const brandRed = [204, 0, 0];             // "Invoice" title
    const headerGrey = [68, 68, 68];          // table header bg (deep grey)
    const lightGrey = [245, 245, 245];        // alt rows
    const textGrey = [90, 90, 90];

    // Small helpers
    const lineGap = (n = 1) => n * 5;
    const text = (t, x, y, opts) => pdf.text(String(t ?? ""), x, y, opts);

    // ---------- HEADER LEFT (Logo + Org Address UNDER LOGO) ----------
    let y = margin;

    if (settings.organization_logo) {
      try {
        // Draw logo at top-left
        pdf.addImage(settings.organization_logo, "PNG", margin, y, 28, 28);
      } catch (e) {
        console.warn("Logo draw failed:", e);
      }
    }

    // Org name + address under logo
    const addrX = margin; // same as logo X
    let addrY = y + 32 + 4; // start a few mm below logo

    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(12);
    pdf.setTextColor(222, 98, 47);
    text(settings.org_name || "Totum Farm", addrX, addrY);
    addrY += 5; // small gap after org name

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9);
    pdf.setTextColor(textGrey[0], textGrey[1], textGrey[2]);

    const addrLines = [
      settings.org_address_line1,
      settings.org_address_line2,
      [settings.org_city, settings.org_country].filter(Boolean).join(", "),
      settings.contact_number ? `Tel: ${settings.contact_number}` : null,
    ].filter(Boolean);

    addrLines.forEach((ln) => {
      text(ln, addrX, addrY);
      addrY += 4.2;
    });


    // ---------- HEADER RIGHT (Title + # + Balance Due box) ----------
    const rightX = pageW - margin;
    let rY = margin + 2;

    // Title
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(22);
    pdf.setTextColor(222, 98, 47);
    text("Invoice", rightX, rY, { align: "right" });
    rY += 8;

    // Invoice number small row
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9);
    pdf.setTextColor(0, 0, 0);
    text(`# ${invoice.invoiceNumber || "N/A"}`, rightX, rY, { align: "right" });
    rY += 10;

    // Balance Due label
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(9);
    text("Balance Due", rightX, rY, { align: "right" });
    rY += 6;

    // Balance Due dark box
    pdf.setTextColor(0, 0, 0);
    pdf.setFont("helvetica", "bold"); 
    pdf.setFontSize(14);
    text(currency(invoice.finalAmount || 0), rightX, rY, { align: "right" });

    // reset text color for body
    pdf.setTextColor(0, 0, 0);

    // ---------- BILL TO + DATE + TERMS ROW ----------
    const boxH = 12;
    y = Math.max(addrY, rY + boxH + 14);

    // Left column: Bill To
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(10);
    text("Bill To", margin, y);
    y += 5;

    // Customer ID
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(10);
    pdf.setTextColor(222, 98, 47);
    text(`${invoice.customerId || "N/A"}`, margin, y);
    y += 5;

    // Customer name
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(10);
    pdf.setTextColor(222, 98, 47);
    text(invoice.customerName || "Customer", margin, y);
    y += lineGap(1);

    // Right side meta (two columns like sample)
    const metaTop = y - 11;
    const col1X = pageW - margin - 70;
    const col2X = pageW - margin;

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9);
    pdf.setTextColor(textGrey[0], textGrey[1], textGrey[2]);
    text("Invoice Date:", col1X, metaTop);

    // Due date
    text("Due Date:", col1X, metaTop + 4.2);

    pdf.setFont("helvetica", "normal");
    pdf.setTextColor(0, 0, 0);
    text(
      invoice.createdAt || "N/A",
      col2X,
      metaTop,
      { align: "right" }
    );

    text(
      invoice.dueDate || "N/A",
      col2X,
      metaTop + 4.2,
      { align: "right" }
    );

    // divider line
    pdf.setDrawColor(230, 230, 230);
    pdf.line(margin, y, pageW - margin, y);
    y += 6;

    // ---------- ITEMS TABLE (like sample: #, Item, Qty, Rate, Amount) ----------
    const items = Array.isArray(invoice.items) ? invoice.items : [];
    const tableStartY = y;

    const rows = items.length
      ? items.map((it, i) => [
          i + 1,                              // #
          it.productCode || "-",              // Product Code
          it.productName || it.description || "Item", // Item
          (it.quantity ?? 0).toString(),      // Qty
          it.unit || "Unit",                  // Unit
          currency(it.unitPrice ?? it.rate ?? 0), // Rate
          currency(it.totalPrice ?? ((it.quantity ?? 0) * (it.unitPrice ?? 0))), // Amount
        ])
      : [[1, "-", "—", "0", "Unit", currency(0), currency(0)]];


    pdf.autoTable({
      startY: tableStartY,
      margin: { left: margin, right: margin },
      styles: { font: "helvetica", fontSize: 9, cellPadding: 3, textColor: [0, 0, 0] },
      headStyles: { fillColor: [97, 46, 25], textColor: [222, 98, 47], fontStyle: "bold" },
      alternateRowStyles: { fillColor: lightGrey },
      columnStyles: {
        0: { cellWidth: 10, halign: "center" }, // #
        1: { cellWidth: 32, halign: "left" },   // Product Code
        2: { cellWidth: 47, halign: "left" },   // Item
        3: { cellWidth: 12, halign: "right" },  // Qty
        4: { cellWidth: 15, halign: "left" },   // Unit
        5: { cellWidth: 25, halign: "right" },  // Rate
        6: { cellWidth: 34, halign: "right" },  // Amount
      },
      head: [[ "#","Product Code", "Item", "Qty", "Unit","Rate", "Amount" ]],
      body: rows,
      theme: "grid",
    });

    const tEnd = pdf.lastAutoTable.finalY;

    // ---------- TOTALS BLOCK (right aligned, like sample) ----------
    const totalsX = pageW - margin - 68;
    let ty = tEnd + 6;

    const drawTotalRow = (label, value, bold = false, shaded = false) => {
      const rowH = 8;
      if (shaded) {
        pdf.setFillColor(245, 245, 245);
        pdf.rect(totalsX, ty - 5.8, 68, rowH + 1.2, "F");
      }
      pdf.setFont("helvetica", bold ? "bold" : "normal");
      pdf.setFontSize(10);
      pdf.setTextColor(0, 0, 0);
      text(label, totalsX + 2, ty);
      text(value, totalsX + 66, ty, { align: "right" });
      ty += rowH;
    };

    const subTotal = rows.reduce((s, r) => s + Number(String(r[4]).replace(/[^\d.-]/g, "")), 0);
    drawTotalRow("Sub Total", currency(subTotal), false, false);
    drawTotalRow("Total", currency(invoice.finalAmount ?? subTotal), true, false);
    drawTotalRow("Balance Due", currency(invoice.finalAmount ?? subTotal), true, true);

    // ---------- NOTES ----------
    let footY = ty + 8;
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(10);
    pdf.setTextColor(brandBrown[0], brandBrown[1], brandBrown[2]);
    text("Notes ", margin, footY);

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9);
    pdf.setTextColor(0, 0, 0);

    const notes = settings.invoice_footer_note
      ? `\n${settings.invoice_footer_note}`
      : "";

    if (notes) {
      const w = pageW - margin * 2;
      const lines = pdf.splitTextToSize(notes, w);
      pdf.text(lines, margin, footY);
      footY += lines.length * 4 + 2;
    }

    // ---------- TERMS & CONDITIONS ----------
    footY += 4;
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(10);
    pdf.setTextColor(brandBrown[0], brandBrown[1], brandBrown[2]);
    text("Terms & Conditions", margin, footY);
    footY += 5;

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9);
    pdf.setTextColor(0, 0, 0);

    const terms =
      settings.invoice_footer_terms ||
      `"If you experience any quality issue with our products, please be kind enough to inform us within 24hrs from the day of delivery"`;

    const termsLines = pdf.splitTextToSize(terms, pageW - margin * 2);
    pdf.text(termsLines, margin, footY);

    // ---------- FOOTER THANK YOU ----------
    const bottomY = pageH - margin + 3;
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9);
    pdf.setTextColor(0, 0, 0);
    text("Thank you for your business!", pageW / 2, bottomY - 6, { align: "center" });
    text(`Generated on ${new Date().toLocaleDateString()}`, pageW / 2, bottomY - 2, { align: "center" });

    // ---------- SAVE ----------
    const fileName = `${invoice.invoiceNumber || "Invoice"}.pdf`;
    pdf.save(fileName);
  } catch (error) {
    console.error("Error printing invoice:", error);
  }
};


  const handlePrint = async (event, invoiceNumber) => {
    event.stopPropagation()
    const invoiceData = await getInvoiceById(invoiceNumber)
    if (invoiceData) {
      handlePrintInvoice(invoiceData)
      
    } else {
    }
  }

  const fetchOrganizationSettings = async () => {
          try {
            const token = localStorage.getItem("token");
            if (!token) {
              toast.error("Authentication token is missing. Please log in again.");
              return;
            }
      
            const response = await axios.get(`${API_BASE_URL}/organizations/getSettings`, {
              headers: { Authorization: `Bearer ${token}` },
            });
      
            setOrganizationContactNo(response.data.contact_number);
            setOrganizationContactName(response.data.contact_name);
          } catch (error) {
            toast.error("Error fetching organization settings.");
          }
        };

  // Send Invoice via WhatsApp
  const handleSendInvoiceViaWhatsApp = async (event, invoiceNumber) => {
    event.stopPropagation()


    try {
      const token = localStorage.getItem("token")
      if (!token) {
        toast.error("Authentication token is missing. Please log in again.")
        return
      }

      const response = await axios.get(`${API_BASE_URL}/invoices/get/for_send_invoice/${invoiceNumber}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })


      const invoiceData = await getInvoiceById(invoiceNumber)

      if (invoiceData) {
      } else {
      }


      const shortLink = response.data?.invoiceURL

      if (!shortLink) {
        toast.error(`Failed to generate order link for ${invoiceData.customerName}`)
        return
      }

      const formattedInvoiceData = {
        phoneNumber: invoiceData.customerMobile,
        customerName: invoiceData.customerName,
        invoiceNumber: invoiceData.invoiceNumber,
        salesOrderNumber: invoiceData.salesOrderNumber,
        customerId: invoiceData.customerId,
        taxAmount: String(invoiceData.taxAmount),
        finalAmount: String(invoiceData.finalAmount),
        latitude: invoiceData.latitude,
        longitude: invoiceData.longitude,
      }


      // Send the WhatsApp message
      const whatsappResponse = await axios.post(`${API_BASE_URL}/sendwhatsapp/sendwhatsapp`, {
        phoneNumber: formattedInvoiceData.phoneNumber,
        customerName: formattedInvoiceData.customerName,
        invoiceNumber: formattedInvoiceData.invoiceNumber,
        salesOrderNumber: formattedInvoiceData.salesOrderNumber,
        customerId: formattedInvoiceData.customerId,
        taxAmount: formattedInvoiceData.taxAmount,
        finalAmount: formattedInvoiceData.finalAmount,
        shortLink: shortLink,
        organizationContactNumber: organizationContactNo, // Use the fetched organization contact number
        organizationContactName: organizationContactName,
        locationURI: `maps/search/?api=1&query=${formattedInvoiceData.latitude},${formattedInvoiceData.longitude}`,
        messageType: "invoice", // Add messageType to the request body
      })


      if (whatsappResponse.data.success) {
        toast.success(`Message sent successfully to ${invoiceData.customerName}`)
      } else {
        toast.error(`Failed to send message to ${invoiceData.customerName}`)
      }
    } catch (error) {
      console.error("Error sending invoice via WhatsApp:", error)
      toast.error("Failed to send invoice. Please try again.")
    }
  }
  const viewInvoice = async (event, invoiceNumber) => {
    event.stopPropagation()
    const invoiceData = await getInvoiceById(invoiceNumber)
    if (invoiceData) {
      setSelectedInvoice(invoiceData) // Set state only for viewing
    }
  }

  const cancelInvoice = async(invoiceId) => {
  
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token is missing. Please log in again.");
          return;
        }
  
        const response = await axios.post(`${API_BASE_URL}/invoices/cancel`, {invoiceId}, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        toast.success("Invoice cancelled successfully!");
        await fetchInvoices();
      }
      catch (error) {
        if (error.response && error.response.status === 400) {
          if (error.response.data.message === "An invoice has already been created for this sales order.") {
            toast.error("Cannot Cancel: An Invoice has already been created.");
          } else {
            toast.error(error.response.data.message || "Failed to cancel Invoice.");
          }
        } else {
          toast.error("Failed to cancel invoice. Please try again.");
        }
      }
    }

  const handleCancelClick = (id) => {
    setSelectedInvoiceIdToCancel(id);
    setConfirmCancelOpen(true);
  };

  const confirmCancel = () => {
    cancelInvoice(selectedInvoiceIdToCancel);
    setConfirmCancelOpen(false);
    setSelectedInvoiceIdToCancel(null);
  };

  const cancelDialog = () => {
    setConfirmCancelOpen(false);
    setSelectedInvoiceIdToCancel(null);
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      setSelectedRows(invoices.map((invoice) => invoice.id))
    } else {
      setSelectedRows([])
    }
  }

  const handleCheckboxChange = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id))
    } else {
      setSelectedRows([...selectedRows, id])
    }
  }

  const sortedInvoices = [...invoices].sort((a, b) => new Date(b.originalCreatedAt) - new Date(a.originalCreatedAt))

  const applyDateFilter = (invoices) => {
    if (!startDate && !endDate) return invoices

    return invoices.filter((invoice) => {
      // Skip if no originalCreatedAt
      if (!invoice.originalCreatedAt) return false

      const invoiceDate = new Date(invoice.originalCreatedAt)

      // Check start date if provided
      if (startDate) {
        const parsedStartDate = parse(startDate, "yyyy-MM-dd", new Date())
        if (!(isAfter(invoiceDate, parsedStartDate) || isEqual(invoiceDate, parsedStartDate))) {
          return false
        }
      }

      // Check end date if provided
      if (endDate) {
        const parsedEndDate = parse(endDate, "yyyy-MM-dd", new Date())
        if (!(isBefore(invoiceDate, parsedEndDate) || isEqual(invoiceDate, parsedEndDate))) {
          return false
        }
      }

      return true
    })
  }

  const dateFilteredInvoices = applyDateFilter(sortedInvoices)

  const filteredInvoices = dateFilteredInvoices.filter((invoice) => {
    switch (selectedSearchField) {
      case "invoiceNumber":
        return invoice.invoiceNumber.toLowerCase().includes(searchTerm.toLowerCase())
      case "salesOrderNumber":
        return invoice.salesOrderNumber.toLowerCase().includes(searchTerm.toLowerCase())
      case "customerId":
        return invoice.customerId.toLowerCase().includes(searchTerm.toLowerCase())
      case "customerName":
        return invoice.customerName.toLowerCase().includes(searchTerm.toLowerCase())
      case "status":
        return invoice.status.toLowerCase().includes(searchTerm.toLowerCase())
      default:
        return false
    }
  })

  useEffect(() => {
    // Calculate totals whenever filtered invoices change
    let invoiceTotal = 0
    let balanceTotal = 0

    filteredInvoices.forEach((invoice) => {
      if (invoice.status !== "Cancelled") {
        invoiceTotal += Number(invoice.finalAmount) || 0
        balanceTotal += Number(invoice.balance) || 0
      }    
    })

    setTotalInvoiceAmount(invoiceTotal)
    setTotalBalanceAmount(balanceTotal)
  }, [filteredInvoices])

  // Add totals row to the filtered invoices
  const filteredInvoicesWithTotals = [
    ...filteredInvoices,
    {
      id: "totals-row",
      invoiceNumber: "",
      salesOrderNumber: "",
      customerId: "",
      customerName: "TOTAL",
      customerMobile: "",
      createdAt: "",
      dueDate: "",
      taxAmount: 0,
      finalAmount: totalInvoiceAmount,
      balance: totalBalanceAmount,
      status: "",
      isTotal: true,
    },
  ]

  const columns = [
    // {
    //     field: "select", headerName: (
    //     <input
    //         type="checkbox"
    //         onChange={(e) => handleSelectAll(e.target.checked)}
    //         checked={selectedRows.length === invoices.length}
    //     />
    //     ),
    //     width: 50,
    //     renderCell: (params) => (
    //         <input
    //             type="checkbox"
    //             checked={selectedRows.includes(params.row.id)}
    //             onChange={() => handleCheckboxChange(params.row.id)}
    //         />
    //     ),
    // },

    {
      field: "invoiceNumber",
      headerName: "Invoice Number",
      flex: 1,
      renderCell: (params) => {
        if (params.row.isTotal) return ""
        return params.value
      },
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.isTotal) return ""
        return params.value
      },
    },
    {
      field: "salesOrderNumber",
      headerName: "Sales Order Number",
      flex: 1,
      renderCell: (params) => {
        if (params.row.isTotal) return ""
        return params.value
      },
    },
    {
      field: "customerId",
      headerName: "Customer ID",
      flex: 1,
      renderCell: (params) => {
        if (params.row.isTotal) return ""
        return params.value
      },
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      flex: 1,
      renderCell: (params) => {
        if (params.row.isTotal) {
          return <span style={{ fontWeight: "bold", color: "#374151" }}>{params.value}</span>
        }
        return params.value
      },
    },
    {
      field: "customerMobile",
      headerName: "Mobile Number",
      width: 150,
      renderCell: (params) => {
        if (params.row.isTotal) return ""
        return params.value
      },
    },
    {
      field: "dueDate",
      headerName: "Due Date",
      flex: 1,
      renderCell: (params) => {
        if (params.row.isTotal) return ""
        return params.value
      },
    },
    {
      field: "taxAmount",
      headerName: "Tax Amount (LKR)",
      flex: 1,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        if (params.row.isTotal) return ""
        return `${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value)}`
      },
    },
    {
      field: "finalAmount",
      headerName: "Final Amount (LKR)",
      flex: 1,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        if (params.row.isTotal) {
          return (
            <span style={{ fontWeight: "bold", color: "#059669" }}>
              {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                params.value,
              )}
            </span>
          )
        }
        return `${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value)}`
      },
    },
    {
      field: "balance",
      headerName: "Balance (LKR)",
      flex: 1,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        if (params.row.isTotal) {
          return (
            <span style={{ fontWeight: "bold", color: "#DC2626" }}>
              {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                params.value,
              )}
            </span>
          )
        }
        return `${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value)}`
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.isTotal) return ""

        const status = params.row.status

        // Map statuses to classes
        const statusClassMap = {
          Unsettled: "bg-[#FBC02D] text-white",
          "Partially Settled": "bg-[#8BC34A] text-white",
          "Fully Settled": "bg-[#90A4AE] text-white",
        }

        // Get the class based on status or default to a neutral color
        const statusClass = statusClassMap[status] || "bg-gray-500 text-white" // Default class if status not found

        return <span className={`px-2 py-1 rounded-sm ${statusClass}`}>{status}</span>
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        if (params.row.isTotal) return ""

        return (
          <div className="flex justify-center items-center p-3 space-x-1">
            <button
                        onClick={() => handleCancelClick(params.row.id)}
                        className="bg-[#d82828] text-white p-2 flex items-center justify-center"
                      >
                        <FaTimes className="text-white" />
                      </button>
            <button
              onClick={(event) => {
                event.stopPropagation()
                viewInvoice(event, params.row.invoiceNumber)
              }}
              className="bg-[#FBC02D] text-white p-2 flex items-center justify-center"
            >
              <FaEye className="text-white" />
            </button>
            <button
              onClick={(event) => {
                event.stopPropagation()
                handleSendInvoiceViaWhatsApp(event, params.row.invoiceNumber)
              }}
              className="bg-[#8BC34A] text-white p-2 flex items-center justify-center"
              style={{ width: "30px", height: "30px" }}
            >
              <FaShareAlt className="text-white" />
            </button>
            <button
              onClick={(event) => {
                event.stopPropagation()
                handlePrint(event, params.row.invoiceNumber)
              }}
              className="bg-[#4CAF50] text-white p-2 flex items-center justify-center"
              style={{ width: "30px", height: "30px" }}
            >
              <FaDownload className="text-white" />
            </button>
          </div>
        )
      },
    },
  ]

  return (
    <div className="flex h-screen">
      <div className="flex-1 p-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-green-700">Invoices</h1>
        </div>

        <div className="bg-white p-4 rounded-lg shadow mb-8">
          <div className="flex flex-col space-y-4 mb-4">
            {/* Top row: Filters and Download button */}
            <div className="flex justify-between items-center">
              {/* Left side: Filters and summary */}
              <div className="flex items-center flex-wrap gap-4">
                <div>
                  <select
                    className="px-4 py-2 border border-gray-300 rounded-lg"
                    value={selectedSearchField}
                    onChange={(e) => setSelectedSearchField(e.target.value)}
                  >
                    <option value="invoiceNumber">Invoice Number</option>
                    <option value="salesOrderNumber">Sales Order Number</option>
                    <option value="customerId">Customer ID</option>
                    <option value="customerName">Customer Name</option>
                    <option value="status">Status</option>
                  </select>
                </div>

                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search Invoices"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="px-4 py-2 pl-10 border border-gray-300 rounded-lg w-full max-w-xs"
                  />
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <FontAwesomeIcon icon={faSearch} className="text-gray-500" />
                  </div>
                </div>

                <div className="flex items-center space-x-2">
                  <label className="text-sm font-medium">From:</label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="px-2 py-1 border border-gray-300 rounded-lg"
                  />
                </div>

                <div className="flex items-center space-x-2">
                  <label className="text-sm font-medium">To:</label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="px-2 py-1 border border-gray-300 rounded-lg"
                  />
                </div>

                <button
                  onClick={() => {
                    setStartDate("");
                    setEndDate("");
                  }}
                  className="px-3 py-1 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
                >
                  Clear
                </button>

                <div className="flex items-center space-x-2">
                  <label className="text-lg font-semibold">Total Invoice Amount (LKR):</label>
                  <span className="text-lg font-bold text-green-700">
                    {new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(totalInvoiceAmount)}
                  </span>
                </div>

                <div className="flex items-center space-x-2">
                  <label className="text-lg font-semibold">Total Outstanding Amount (LKR):</label>
                  <span className="text-lg font-bold text-red-600">
                    {new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(totalBalanceAmount)}
                  </span>
                </div>
              </div>

              {/* Right side: Download button */}
              <div>
                <button
                  onClick={handleDownloadExcel}
                  className="flex items-center bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
                >
                  <FaDownload className="mr-2" />
                  Download Excel
                </button>
              </div>
            </div>
          </div>
          <div style={{ width: "100%" }}>
            <style jsx>{`
              :global(.MuiDataGrid-row:last-child) {
                position: sticky !important;
                bottom: 0 !important;
                background-color: #f8f9fa !important;
                border-top: 2px solid #dee2e6 !important;
                font-weight: bold !important;
                z-index: 1 !important;
              }
              :global(.MuiDataGrid-row:last-child .MuiDataGrid-cell) {
                background-color: #f8f9fa !important;
                border-top: 2px solid #dee2e6 !important;
              }
            `}</style>
            <Grid rows={filteredInvoicesWithTotals} columns={columns} getRowId={(row) => row.id} />
            {selectedInvoice && (
              <div
                className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
                style={{ overflowY: "auto" }}
              >
                <div
                  className="bg-white p-8 rounded-lg shadow-lg w-full md:w-2/3 lg:w-1/2 relative max-h-[90vh] overflow-y-auto"
                  style={{ maxHeight: "90vh", overflowY: "auto" }}
                >
                  <button
                    onClick={() => setSelectedInvoice(null)}
                    className="absolute top-2 right-2 bg-red-500 text-white w-8 h-8 flex justify-center items-center rounded-lg hover:bg-red-700"
                  >
                    &times;
                  </button>
                  <h2 className="text-3xl font-bold mb-4">Invoice Details</h2>
                  <div className="mb-4">
                    <label className="block text-black-700 font-semibold">Created Date</label>
                    <input
                      type="text"
                      value={selectedInvoice.createdAt || ""}
                      readOnly
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-black-700 font-semibold">Invoice Number</label>
                    <input
                      type="text"
                      value={selectedInvoice.invoiceNumber || ""}
                      readOnly
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-black-700 font-semibold">Sales Order Number</label>
                    <input
                      type="text"
                      value={selectedInvoice.salesOrderNumber || ""}
                      readOnly
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-black-700 font-semibold">Customer ID</label>
                    <input
                      type="text"
                      value={selectedInvoice.customerId || ""}
                      readOnly
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-black-700 font-semibold">Customer Name</label>
                    <input
                      type="text"
                      value={selectedInvoice.customerName || ""}
                      readOnly
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-black-700 font-semibold">Mobile Number</label>
                    <input
                      type="text"
                      value={selectedInvoice.customerMobile || ""}
                      readOnly
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>
                  <div className="mb-4">
                    <label className="block text-black-700 font-semibold">Taxt Amount (LKR)</label>
                    <input
                      type="text"
                      value={new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(selectedInvoice.taxAmount || 0)}
                      readOnly
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>
                  <div className="mb-4 grid grid-cols-2 gap-4">
                    <div className="mb-4">
                      <label className="block text-black-700 font-semibold">Final Amount (LKR)</label>
                      <input
                        type="text"
                        value={new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(selectedInvoice.finalAmount || 0)}
                        readOnly
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block text-black-700 font-semibold">Balance (LKR)</label>
                      <input
                        type="text"
                        value={new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(selectedInvoice.balance || 0)}
                        readOnly
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                      />
                    </div>
                  </div>
                  {/* Display payment receipts */}
                  <h3 className="text-lg font-semibold mt-4 mb-2">Products</h3>
                  <DataGrid
                    rows={selectedInvoice.items.map((product, index) => ({
                      id: index + 1,
                      product_code: product.productCode,
                      productName: product.productName,
                      unitPrice: new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(product.unitPrice),
                      quantity: product.quantity,
                      unit: product.unit,
                      totalPrice: new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(product.totalPrice),
                    }))}
                    columns={[
                      { field: "id", headerName: "Number", width: 80, flex: 0.8 },
                      { field: "product_code", headerName: "Product ID", width: 150, flex: 1 },
                      { field: "productName", headerName: "Product Name", width: 140, flex: 1 },
                      {
                        field: "quantity",
                        headerName: "Quantity",
                        width: 140,
                        flex: 1,
                        headerAlign: "right",
                        align: "right",
                      },
                      {
                        field: "unit",
                        headerName: "Units",
                        flex: 1,
                        headerAlign: "center",
                        align: "center",
                      },
                      {
                        field: "unitPrice",
                        headerName: "Unit Price (LKR)",
                        width: 140,
                        flex: 1,
                        headerAlign: "right",
                        align: "right",
                      },
                      {
                        field: "totalPrice",
                        headerName: "Total Price (LKR)",
                        width: 140,
                        flex: 1,
                        headerAlign: "right",
                        align: "right",
                      },
                    ]}
                  />
                  <div className="grid grid-cols-2 gap-4">
                    <h3 className="text-lg font-semibold mt-4 mb-2">Payment Receipts</h3>
                    <h3 className="text-lg font-semibold mt-4 mb-2">Credit Notes</h3>
                  </div>
                  <div className="mb-4 grid grid-cols-2 gap-4">
                    <div>
                      <DataGrid
                        rows={selectedInvoice.payment_receipts.map((receipt, index) => ({
                          id: index + 1,
                          receiptId: receipt.payment_receipt_id?.payment_receipt_id || "Null", // Make sure this path is correct
                          amount_applied: new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(receipt.amount_applied),
                        }))}
                        columns={[
                          { field: "id", headerName: "Number", width: 80, flex: 0.3 },
                          { field: "receiptId", headerName: "Payment Receipt ID", width: 150, flex: 1 },
                          {
                            field: "amount_applied",
                            headerName: "Applied Amount",
                            width: 140,
                            flex: 1,
                            headerAlign: "right",
                            align: "right",
                          },
                        ]}
                      />
                    </div>
                    <div>
                      <DataGrid
                        rows={selectedInvoice.credit_notes.map((note, index) => ({
                          id: index + 1,
                          noteId: note.credit_note_id || "Null", // Make sure this path is correct
                          amount_credited: new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(note.credited_amount),
                        }))}
                        columns={[
                          { field: "id", headerName: "Number", width: 80, flex: 0.3 },
                          { field: "noteId", headerName: "Credit Note ID", width: 150, flex: 1 },
                          {
                            field: "amount_credited",
                            headerName: "Credited Amount",
                            width: 140,
                            flex: 1,
                            headerAlign: "right",
                            align: "right",
                          },
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {confirmCancelOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-md w-80">
          <h2 className="text-lg font-semibold mb-4">Confirm Cancellation</h2>
          <p className="mb-6">Are you sure you want to cancel this Invoice?</p>
          <div className="flex justify-end space-x-4">
            <button onClick={cancelDialog} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
            <button onClick={confirmCancel} className="bg-red-600 text-white px-4 py-2 rounded">Confirm</button>
          </div>
        </div>
      </div>
    )}
    </div>
  )
}

export default Invoices
